import { useState } from 'react'
import { X, ArrowLeft } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Card } from '../types'
import { useAppStore } from '../store'
import { PackOpening3D } from '../components/packs/PackOpening3D'

const PACKS = [
  {
    id: 'hijos-daana',
    name: 'Hijos de Daana',
    image: '/images/sobres/sobre_hijos_daana.png',
    edition: 'Lista de cartas de Hijos de Daana'
  },
  {
    id: 'tierras-altas',
    name: 'Tierras Altas',
    image: '/images/sobres/sobre_tierras_altas.png',
    edition: 'Lista de cartas de Tierras Altas'
  },
  {
    id: 'dominios-ra',
    name: 'Dominios de Ra',
    image: '/images/sobres/sobre_dominios_ra.png',
    edition: 'Lista de cartas de Dominios de Ra'
  }
]

export default function PackPage() {
  const storeCards = useAppStore((state) => state.cards)
  const cards = Array.isArray(storeCards) ? storeCards : []
  const [selectedPack, setSelectedPack] = useState<typeof PACKS[0] | null>(null)
  const [revealedCards, setRevealedCards] = useState<Card[]>([])

  const handleOpenPack = (pack: typeof PACKS[0]) => {
    setSelectedPack(pack)
    setRevealedCards([])
  }

  const handlePackOpeningComplete = () => {
    const targetEdition = selectedPack!.edition
    const editionCards = cards.filter(card => card.edition === targetEdition)

    let randomCards: Card[]
    if (editionCards.length === 0) {
      const partialMatch = cards.filter(card =>
        card.edition.toLowerCase().includes(targetEdition.toLowerCase())
      )
      randomCards = partialMatch
        .sort(() => Math.random() - 0.5)
        .slice(0, Math.min(10, partialMatch.length))
    } else {
      randomCards = editionCards
        .sort(() => Math.random() - 0.5)
        .slice(0, Math.min(10, editionCards.length))
    }

    setRevealedCards(randomCards)
  }

  const handleClose = () => {
    setSelectedPack(null)
    setRevealedCards([])
  }

  return (
    <div className="min-h-screen bg-[#0f1115] py-16">
      {!selectedPack && (
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-slate-400 hover:text-white mb-8 transition-colors"
          >
            <ArrowLeft size={20} />
            Volver al inicio
          </Link>

          <h1 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center">
            Abre <span className="text-amber-400">Sobres</span>
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full max-w-4xl">
            {PACKS.map((pack) => (
              <button
                key={pack.id}
                onClick={() => handleOpenPack(pack)}
                className="group relative bg-[#1a1e24] rounded-2xl p-8 border border-[#2d3540] hover:border-amber-500/50 transition-all hover:scale-105 hover:shadow-2xl hover:shadow-amber-500/10"
              >
                <img
                  src={pack.image}
                  alt={pack.name}
                  className="w-full h-48 object-contain mb-4 transition-transform group-hover:scale-110"
                />
                <h3 className="text-2xl font-semibold text-white text-center">
                  {pack.name}
                </h3>
              </button>
            ))}
          </div>
        </div>
      )}

      {selectedPack && (
        <div className="fixed inset-0 bg-[#0f1115] z-50 flex flex-col">
          <button
            onClick={handleClose}
            className="absolute top-4 left-4 p-2 text-slate-400 hover:text-white transition-colors z-50"
          >
            <X size={24} />
          </button>

          <PackOpening3D
            packTexture={selectedPack.image}
            onComplete={handlePackOpeningComplete}
            onCardReveal={() => {}}
            revealedCards={revealedCards}
          />
        </div>
      )}
    </div>
  )
}
